// All API calls go through here.
// In dev, Vite proxies /api → localhost:3001
// In production (Vercel), /api routes hit serverless functions

export async function getRecommendations({ query, activeServices, prefs, region }) {
  const res = await fetch('/api/recommend', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ query, activeServices, prefs, region }),
  })
  if (!res.ok) {
    const err = await res.json().catch(() => ({}))
    throw new Error(err.error || `Server error ${res.status}`)
  }
  return res.json() // returns { results: [...enriched recs with .watch availability] }
}

export async function searchActor({ name, activeServices, region }) {
  const params = new URLSearchParams({ q: name, region: region || 'US' })
  if (activeServices?.length) params.set('services', activeServices.join(','))
  const res = await fetch(`/api/search/person?${params}`)
  if (!res.ok) {
    const err = await res.json().catch(() => ({}))
    throw new Error(err.error || `Server error ${res.status}`)
  }
  return res.json() // { person: { id, name, profile, known_for_department }, movies: [...] }
}

export async function getTrending(region) {
  const url = region ? `/api/trending?region=${encodeURIComponent(region)}` : '/api/trending'
  const res = await fetch(url)
  if (!res.ok) {
    const err = await res.json().catch(() => ({}))
    throw new Error(err.error || `Server error ${res.status}`)
  }
  return res.json() // returns { results: [...trending items], cached }
}
